interface Props {
    onClick?: () => void;
}

function CloseIcon({ onClick }:Props) {
  return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
             onClick={onClick}
             style={{
               position: 'absolute', right: 24, cursor: 'pointer',
             }} >
            <path fillRule="evenodd" clipRule="evenodd"
                  d="M19.5659 5.56568C19.8783 5.25326 19.8783 4.74673 19.5659 4.43431C19.2535 4.12189 18.7469 4.12189 18.4345 4.43431L12.0002 10.8686L5.56589 4.43432C5.25347 4.1219 4.74694 4.1219 4.43452 4.43432C4.1221 4.74674 4.1221 5.25327 4.43452 5.56569L10.8688 12L4.43451 18.4343C4.12209 18.7467 4.12209 19.2532 4.43451 19.5657C4.74693 19.8781 5.25346 19.8781 5.56588 19.5657L12.0002 13.1314L18.4345 19.5657C18.7469 19.8781 19.2535 19.8781 19.5659 19.5657C19.8783 19.2533 19.8783 18.7467 19.5659 18.4343L13.1316 12L19.5659 5.56568Z"
                  fill="#64696E"/>
        </svg>
  );
}

export default CloseIcon;
